import { Stack, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { formatISO, isValid, lastDayOfQuarter, parseISO, subQuarters } from "date-fns";
import { useState } from "react";
import useDebounce from "@entrilia/shared/hooks/useDebounce";
import InvestorInvestmentsData from "./InvestorInvestmentsData";

const minReportingDate = parseISO("1970-01-01");
const datePickerSlotProps = { textField: { sx: { width: "10rem" } } };

interface Props {
  investorId: string;
}

const InvestorDetailsInvestmentsTab = ({ investorId }: Props) => {
  const [reportingDate, setReportingDate] = useState<Date | undefined>(() =>
    lastDayOfQuarter(subQuarters(new Date(), 1))
  );

  const handleReportingDateChange = useDebounce((date: Date | null) => setReportingDate(date ?? undefined), 300);

  const selectedDate =
    reportingDate && isValid(reportingDate) && reportingDate >= minReportingDate
      ? formatISO(reportingDate, { representation: "date" })
      : undefined;

  return (
    <Stack spacing={2.5} sx={{ height: "100%" }}>
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        <Typography color="textSecondary">Effective reporting date:</Typography>
        <DatePicker
          value={reportingDate ?? null}
          onChange={handleReportingDateChange}
          minDate={minReportingDate}
          slotProps={datePickerSlotProps}
        />
      </Stack>
      {selectedDate ? (
        <InvestorInvestmentsData key={selectedDate} investorId={investorId} reportingDate={selectedDate} />
      ) : (
        <Typography color="textSecondary">Select a valid reporting date to view investments.</Typography>
      )}
    </Stack>
  );
};

export default InvestorDetailsInvestmentsTab;
